import React from 'react';
import { Card } from 'react-bootstrap';
import { } from 'react-router-dom'

export default function ProfileDocumentsComp({ profile }) {

    return (<>
        <div className='tab-header'>
            <h2>Document Preferences</h2>
            <p>View your legal documents</p>
        </div>
        <Card className="tab-box">
            <div className="tab-box-wrap">
                <h5>My Documents</h5>
                <div className="info-box">
                    <div className='info-box-text'>
                        <div className='d-flex flex-column'>
                            <h6>EARB CERTIFICATE</h6>
                            <span>Issue Date: {new Date(profile.earb_issued_date).toLocaleDateString()}</span>
                        </div>
                    </div>
                    <div className="d-flex gap-2 profile-bttn-group">
                        <a
                            href={profile.earb_certificate_file}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="custom-bttn style-2"
                        >
                            View Certificate
                        </a>

                    </div>
                </div>
                <div className="info-box">
                    <div className='info-box-text'>
                        <div className='d-flex flex-column'>
                            <h6>ID / PASSPORT NUMBER</h6>
                            <span>ID / Passport Number: {profile.id_or_passport_number}</span>
                        </div>
                    </div>
                    <div className="d-flex gap-2 profile-bttn-group">
                        <a
                            href={profile.id_document}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="custom-bttn style-2"
                        >
                            View Document
                        </a>

                    </div>
                </div>
            </div>
        </Card>
    </>
    );
}
